<div class="row w-100 justify-content-end" style="width: 100%">
    <div class="col-md-6"></div>

    <div class="col-md-6 col-lg-6 col-xl-6" style="top: 10px; margin-left: -18px" *ngIf="JointData?.namePrimary">
        <div class="d-flex justify-content-end align-items-center label-wrapper">
            <p class="tightening-title">
                Tagged Item <span>{{ JointData?.namePrimary }}</span>
            </p>
        </div>
    </div>
</div>

<div class="row mt-5" *ngIf="linkEntityType != LinkEntityType.TaggedItem">
    <div class="col-md-5">
        <div class="breadcume d-flex align-items-center py-3">
            <div class="breadcume-item">
                <h3 class="m-0" style="font-size: 14px" #tooltip="matTooltip" [matTooltip]="currentInstanceName" [matTooltipPosition]="tooltip_position">
                    <a href="javascript:void(0)" (click)="backToRoute()">{{ currentInstanceName | truncate: 15 }}</a>
                    <i class="fa fa-angle-right" aria-hidden="true" style="font-size: 14px; margin: 0px 5px; color: #337ab7"></i>
                </h3>
            </div>
            <div class="breadcume-item">
                <h3 class="m-0" style="font-size: 14px">
                    <a
                        href="javascript:void(0)"
                        (click)="projectBreadCrumbClick(projectManagerService?.selectedProjectData?.projectId)"
                        #tooltip="matTooltip"
                        [matTooltip]="selectedProject?.namePrimary"
                        [matTooltipPosition]="tooltip_position"
                        >{{ selectedProject?.namePrimary | truncate: 15 }}</a
                    >
                    <i
                        class="fa fa-angle-right"
                        *ngIf="activityPackDetails?.namePrimary"
                        aria-hidden="true"
                        style="font-size: 14px; margin: 0px 5px; color: #337ab7"
                    ></i>
                </h3>
            </div>
            <div class="breadcume-item" *ngIf="activityPackDetails?.namePrimary">
                <h3 class="m-0" style="font-size: 14px">
                    <a
                        href="javascript:void(0)"
                        style="cursor: pointer"
                        (click)="projectBreadCrumbClick(projectManagerService?.selectedProjectData?.projectId, activityPackDetails?.activityPackId)"
                        #tooltip="matTooltip"
                        [matTooltip]="activityPackDetails?.namePrimary"
                        [matTooltipPosition]="tooltip_position"
                        >{{ activityPackDetails?.namePrimary | truncate: 15 }}</a
                    >
                </h3>
            </div>
        </div>
    </div>

    <div class="col-md-7 col-lg-7 col-xl-7">
        <div class="d-flex justify-content-end align-items-center label-wrapper">
            <p class="tightening-title">
                Project Type
                <span> {{ getProjectType(selectedProject) }}</span>
            </p>
            <p class="tightening-title" *ngIf="activityPackDetails?.activityPackType?.name">
                Work Pack Type <span>{{ activityPackDetails?.activityPackType?.name }}</span>
            </p>
            <p class="tightening-title" *ngIf="activityPackDetails?.activityPackStatus?.name">
                staus <span>{{ activityPackDetails?.activityPackStatus?.name }}</span>
            </p>
        </div>
    </div>
</div>

<div class="row mt-5">
    <div class="col-md-6 col-lg-6 col-xl-4"></div>

    <div class="col-md-6 col-lg-6 col-xl-8">
        <div class="row">
            <div class="col-md-8 col-lg-8 col-xl-8">
                <div class="custom-pagination-wrap">
                    <mat-paginator [pageSize]="15" [length]="_AttachmentsList?.length" showFirstLastButtons> </mat-paginator>
                </div>
            </div>
            <div class="col-md-4 col-lg-4 col-xl-4">
                <div class="d-flex justify-content-end search-wrapper h-100">
                    <mat-form-field class="w-100 example-full-width">
                        <input
                            matInput
                            type="text"
                            placeholder="Enter a search Item"
                            [(ngModel)]="searchText"
                            autocomplete="off"
                            (keyup)="applyFilter($event.target.value)"
                        />
                        <button mat-button matPrefix mat-icon-button class="search_btn">
                            <mat-icon class="serach_icon">search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-md-12">
        <div class="mat-elevation-z8 table_responsive">
            <table mat-table [dataSource]="dataSource" class="mat-table-wrapper">
                <!-- Position Column -->
                <ng-container matColumnDef="documentTittle">
                    <th mat-header-cell *matHeaderCellDef>Document Tittle.</th>
                    <!-- <td mat-cell *matCellDef="let element">{{ element.name }}</td> -->
                    <td
                        mat-cell
                        *matCellDef="let element"
                        class="document-tittle"
                        [matTooltipPosition]="tooltip_position"
                        #tooltip="matTooltip"
                        matTooltip="{{ element.name }}"
                    >
                        <i class="mdi mdi-file-document" *ngIf="element.documentType == 'application/pdf'"></i>
                        <i class="mdi mdi-file-excel" *ngIf="element.documentType == attachmentType.xls || element.documentType == attachmentType.xlsx"></i>
                        <i
                            class="mdi mdi-file-image-outline"
                            *ngIf="
                                element.documentType == attachmentType.jpg ||
                                element.documentType == attachmentType.jpeg ||
                                element.documentType == attachmentType.png
                            "
                        ></i>
                        {{ element.name | truncate: 30 }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="documentNo">
                    <th mat-header-cell *matHeaderCellDef>Document No.</th>
                    <td mat-cell *matCellDef="let element">{{ element.number }}</td>
                </ng-container>

                <ng-container matColumnDef="documentType">
                    <th mat-header-cell *matHeaderCellDef>Document Type</th>
                    <td mat-cell *matCellDef="let element" class="document-type">{{ element.documentType }}</td>
                </ng-container>

                <ng-container matColumnDef="revision">
                    <th mat-header-cell *matHeaderCellDef>Revision.</th>
                    <td mat-cell *matCellDef="let element">{{ element.revision }}</td>
                </ng-container>

                <ng-container matColumnDef="version">
                    <th mat-header-cell *matHeaderCellDef>Version</th>
                    <td mat-cell *matCellDef="let element">{{ element.version }}</td>
                </ng-container>

                <ng-container matColumnDef="added">
                    <th mat-header-cell *matHeaderCellDef>Added</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.createdDate | customDateTimeFormat }}
                        <!-- | date: 'dd/MM/yyyy hh:mm:ss a' -->
                    </td>
                </ng-container>

                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Action</th>
                    <td mat-cell *matCellDef="let row">
                        <div class="icon-wrapper">
                            <mat-icon>
                                <a
                                    class="pi-edit"
                                    href="javascript:void(0)"
                                    #tooltip="matTooltip"
                                    (click)="editAttachment(row)"
                                    matTooltip="Edit"
                                    [matTooltipPosition]="tooltip_position"
                                >
                                    edit
                                </a>
                            </mat-icon>

                            <a
                                href="javascript:void(0)"
                                #tooltip="matTooltip"
                                matTooltip="Download"
                                [matTooltipPosition]="tooltip_position"
                                class="me-5"
                                (click)="downloadAttachment(row)"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    width="24px"
                                    height="24px"
                                    viewBox="0 0 24 24"
                                    version="1.1"
                                >
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <rect x="0" y="0" width="24" height="24" />
                                        <rect
                                            fill="#000000"
                                            opacity="0.3"
                                            transform="translate(12.000000, 7.000000) rotate(-180.000000) translate(-12.000000, -7.000000) "
                                            x="11"
                                            y="1"
                                            width="2"
                                            height="12"
                                            rx="1"
                                        />
                                        <path
                                            d="M17,8 C16.4477153,8 16,7.55228475 16,7 C16,6.44771525 16.4477153,6 17,6 L18,6 C20.209139,6 22,7.790861 22,10 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 L2,9.99305689 C2,7.7839179 3.790861,5.99305689 6,5.99305689 L7.00000482,5.99305689 C7.55228957,5.99305689 8.00000482,6.44077214 8.00000482,6.99305689 C8.00000482,7.54534164 7.55228957,7.99305689 7.00000482,7.99305689 L6,7.99305689 C4.8954305,7.99305689 4,8.88848739 4,9.99305689 L4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,10 C20,8.8954305 19.1045695,8 18,8 L17,8 Z"
                                            fill="#000000"
                                            fill-rule="nonzero"
                                            opacity="0.3"
                                        />
                                        <path
                                            d="M14.2928932,10.2928932 C14.6834175,9.90236893 15.3165825,9.90236893 15.7071068,10.2928932 C16.0976311,10.6834175 16.0976311,11.3165825 15.7071068,11.7071068 L12.7071068,14.7071068 C12.3165825,15.0976311 11.6834175,15.0976311 11.2928932,14.7071068 L8.29289322,11.7071068 C7.90236893,11.3165825 7.90236893,10.6834175 8.29289322,10.2928932 C8.68341751,9.90236893 9.31658249,9.90236893 9.70710678,10.2928932 L12,12.5857864 L14.2928932,10.2928932 Z"
                                            fill="#000000"
                                            fill-rule="nonzero"
                                        />
                                    </g>
                                </svg>
                            </a>

                            <mat-icon
                                #tooltip="matTooltip"
                                matTooltip="Delete Document"
                                [matTooltipPosition]="tooltip_position"
                                (click)="deleteAttachment(row)"
                            >
                                <a href="javascript:void(0)" class="pi-delete">delete</a>
                            </mat-icon>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell error-message" colspan="4">
                        <div *ngIf="dataSource.data.length <= 0; else elseBlock">No data available.</div>
                        <ng-template #elseBlock> No data matching "{{ searchText }}" </ng-template>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>
<div class="row mt-5">
    <div class="col-md-8">
        <div class="btn-wrapper-list">
            <button class="btn secondary-ebtn" (click)="addAttachment()">Add Attachment</button>
            <button class="btn secondary-ebtn" (click)="addMultipleAttachment()">Add Multiple Attachments</button>
        </div>
    </div>
    <div class="col-md-4"></div>
</div>
